import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const genericHeightWeightQuestions = [
  {
    label: 'What is your:',
    field: 'generic_heightWeight2025',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      showCalculatedValues: false
    }
  }
] as const;

export type GenericHeightWeightQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof genericHeightWeightQuestions>
>;

export default genericHeightWeightQuestions;
